<template>
  <div class="content-wrapper">
    <div class="columns">
      <div class="column">
        <margin-title :title="number" subtitle="description" class="margin-title" />
        <h1 class="title is-4"> {{ detail }}</h1>
        <slot></slot>
      </div>
      <div class="column is-one-third">
        <div class="is-fixed">
          <progress-tracker class="tracker"
                            @onContinue="onContinue"
                            :tasks="tasks"
                            :progdetail="progdetail"
                            :formtype="formtype"
                            :disabled = "disabled"
                            :loading="loading" />
          <div v-if="skip" class="is-flex content-center is-flex-column m-t-8">
            <a @click="onSkip">Skip this step</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarginTitle from '@/components/margin-title'
import ProgressTracker from '@/components/progress-tracker'

export default {
  components: { MarginTitle, ProgressTracker },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    progdetail: {
      type: String,
      required: true
    },
    formtype: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    detail: {
      type: String,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    skip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onContinue () {
      this.$emit('continue')
    },
    onSkip () {
      this.$emit('onSkip')
    }
  }
}
</script>

<style scoped>

.margin-title {
  margin-bottom: 40px;
}

.tracker {
  margin-top: 0rem;
}

</style>



// WEBPACK FOOTER //
// src/templates/jobseeker-signup.vue